import useApiQuery from 'shared/hooks/use-api-query';
import {OrderProps} from '../types';
import ordersKeys from '../util/orders-keys';

const useOrder = (orderId?: string) => {
  return useApiQuery<OrderProps>({
    url: `/orders/${orderId}`,
    queryKey: ordersKeys.details(orderId!),
    enabled: !!orderId,
  });
};

export default useOrder;
